<template>
  <div :class="props.customClass">
    <label
    :for="props.fieldName"
    v-html="props.fieldLabel"
    :class="{ 'builderinput-label': props.showLabel }"
    :style="props.showLabel ? undefined : { display: 'none' }"
    ></label>
    <select
    :id="props.fieldName"
    :name="props.fieldName"
    v-model="fieldValue"
    @input="updateValue"
    @change="updateValue"
    @keydown="updateValue"
    @blur="touch"
    aria-required
    :aria-labelledby="`${props.fieldName} ${props.fieldName}Errors`"
    :aria-invalid="!isValid">
      <option value="" :selected="!props.initValue">Please select...</option>
      <option :value="opt.id" v-for="(opt, index) in builder[props.optionsSource]">{{ opt.title }}</option>
    </select>
    <div
    :id="`${props.fieldName}Errors`"
    aria-live="polite"
    aria-relevant="additions removals">
      <div
      v-if="error"
      v-html="error"
      class="builderinput-error">

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
var _ = require('lodash');

const props = defineProps([
  'key',
  'fieldLabel',
  'fieldName',
  'fieldType',
  'displayType',
  'selected',
  'scope',
  'initValue',
  'defaultValue',
  'required',
  'customClass',
  'initTouched',
  'optionsSource',
  'showLabel',
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['updateValue'])

function resolveFieldValue(value) {
  if (value === null || value === undefined || value === '') {
    return props.defaultValue ?? '';
  }
  return value;
}

const fieldValue = ref(resolveFieldValue(props.initValue));
const error = ref('');
let isTouched = false;
let isGood = false;
let errorText = '';
let nonStandard = false;

const isValid = computed(() => {
  if (error.value.length) return false;
  return true;
})

function updateValue() {

  // format value
  let stringValue = fieldValue.value;
  let saveValue = fieldValue.value;

  // if init touched
  if (typeof props.initTouched !== 'undefined' && props.initTouched) isTouched = true;

  if (isTouched) {
    error.value = errorText;
  }

  emit('updateValue', props.fieldName, fieldValue.value);
  if (isTouched) {
    builder.validateCurrentItem();
  }


  if (builder.isTouched) builder.validateCurrentItem();
  // e.preventDefault();
  // return false;
}

function touch(e) {
  isTouched = true;
  updateValue();
}

onMounted(() => {
  if (fieldValue.value !== props.initValue) {
    emit('updateValue', props.fieldName, fieldValue.value);
  }
});

</script>
